import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { FileInfo } from '../../uploader.interface';

@Component({
  selector: 'glxy-image-list',
  templateUrl: './image-list.component.html',
  styleUrls: ['./image-list.component.scss'],
  standalone: false,
})
export class GalaxyImageListComponent {
  @HostBinding('class') class = 'glxy-image-list';

  /** List of files to render image tiles for */
  @Input() files: FileInfo[] = [];

  /** Emits the file to trigger an edit action for */
  @Output() edit: EventEmitter<FileInfo> = new EventEmitter();

  /** Emits the file to trigger a delete action for */
  @Output() delete: EventEmitter<FileInfo> = new EventEmitter();

  /**
   * Called when the edit button has been clicked for an image tile
   * @param info - Information about the file that was selected to be edited
   */
  editClick(info: FileInfo): void {
    this.edit.emit(info);
  }

  /**
   * Called when the delete button has been clicked for an image tile
   * @param info - Information about the file that was selected to be deleted
   */
  deleteClick(info: FileInfo): void {
    this.delete.emit(info);
  }
}
